// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"D_t2 g_jk g_fl g_fp g_fz g_dH g_t","menuItemSub":"D_t3 g_dP g_fl g_fz","menuMainLink":"D_t4 g_jl g_hf","menuLink":"D_t5 g_jl g_hf","Link":"D_r1 t_r1 t_rp t_rK"};